<template>
  <el-dialog title="撤销申请" :visible.sync="visible" width="375px" center append-to-body :before-close="handleCloseDialog">
    <p class="dialog-text text-center">确认撤销申请？</p>
    <span slot="footer" class="dialog-footer">
      <el-button class="red-line" @click="handleCloseDialog">取 消</el-button>
      <el-button class="red-block" @click="handleCancerAftersales">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Undo',
  props: ['visible'],
  data () {
    return {
    }
  },
  methods: {
    handleCloseDialog () {
      this.$emit('handleCloseDialog')
    },
    handleCancerAftersales () {
      this.$emit('handleCancerAftersales')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/common/css/dialog.scss';
</style>
